import { render } from "./SignersDocumentResp.vue?vue&type=template&id=2cda04fb"
import script from "./SignersDocumentResp.vue?vue&type=script&lang=js"
export * from "./SignersDocumentResp.vue?vue&type=script&lang=js"

import "./SignersDocumentResp.vue?vue&type=style&index=0&id=2cda04fb&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__